export default function (request, proxy, wrapper) {
  return wrapper.network
}
